import React, { useEffect, useState, useRef } from "react";
import Navigation from "./Navigation";
import { Footer } from "./Footer";
import Brands from "./Brands";
import { FaFacebookF } from 'react-icons/fa';
import emailjs from "emailjs-com";
import { useTranslation} from "react-i18next";
import Slider from "react-slick";
import { Col, Container, Row, Card, Button } from "react-bootstrap";
import { MdRoofing, MdOutlineContentCut } from "react-icons/md";
import { BsCheckLg } from "react-icons/bs";
import { GoDotFill } from "react-icons/go";
import { products } from "./products";
import GoTop from "./GoTop";
import { GiCircularSawblade, GiOilDrum, GiShield } from "react-icons/gi";


const Home = ({ lang: currentLanguage }) => {
  const [prods, setprods] = useState([]);
  const [tooltipVisible, setTooltipVisible] = useState(null);
  const form = useRef();
  const [aboutTextClass, setaboutTextClass] = useState(''); //lera dastkarim krd baxoy awha bu '' krdama []
  const [activeSlide, setActiveSlide] = useState(0);
const isRTL = currentLanguage.code === "ar" || currentLanguage.code === "kur";


  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_inyaa89",
        "template_993qouc",
        form.current,
        "user_DfrMcD1i8Klde4wR1m0qR"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    form.current.reset();
  };

  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("app_title");
    if (currentLanguage.code === "kur") {
      setprods(products.kur);
    } else if (currentLanguage.code === "ar") {
      setprods(products.ar);
    } else {
      setprods(products.en);
    }

    
  }, [currentLanguage]);
  useEffect(() => {
    const determineaboutTextClass = () => {
      switch (currentLanguage.code) {
        case 'en':
          return 'about-text-en';
        case 'ar':
          return 'about-text-ar';
        case 'kur':
          return 'about-text-kur';
        default:
          return ''; // Fallback class
      }
    };
    setaboutTextClass(determineaboutTextClass());
  }, [currentLanguage]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
 
  const settings = {
    dots: true,
    infinite: true,
    speed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: false,
    prevArrow: false,
    autoplay: true,
    rtl: isRTL, // THIS PREVENTS THE WHITE SCREEN CRASH
  };
  const menu = ["about", "services", "products"];
  
  return (
    <>
      <Navigation navs={menu} />
      
      <div id="topp" className="homeCarousel">
        
        {/* 3. Add the key AND pass the new settings */}
        <Slider key={currentLanguage.code} {...settings}>
          
          <div className={`homeBackground1 `} id="home">
            <div className="backgroundoverlay">
              <Container className="px-md-5 h-100 align-middle homeText">
                <div className="intro-text">
                  <h1 className="mb-4 navMenuFont">{t("app_title")}</h1>
                  <h5 className="h2Font">{t("home1")}</h5>
                </div>
              </Container>
            </div>
          </div>

          <div className="homeBackground2" id="home">
            <div className="backgroundoverlay">
              <Container className="px-md-5 h-100 align-middle homeText">
                <div className="intro-text">
                  <h1 className="mb-4 navMenuFont">{t("app_title")}</h1>
                  <h5 className="h2Font">{t("home2")}</h5>
                </div>
              </Container>
            </div>
          </div>

          <div className="homeBackground3" id="home">
            <div className="backgroundoverlay">
              <Container className="px-md-5 h-100 align-middle homeText">
                <div className="intro-text">
                  <h1 className="mb-4 navMenuFont">{t("app_title")}</h1>
                  <h5 className="h2Font">{t("home3")}</h5>
                </div>
              </Container>
            </div>
          </div>

          <div className="homeBackground4" id="home">
            <div className="backgroundoverlay">
              <Container className="px-md-5 h-100 align-middle homeText">
                <div className="intro-text">
                  <h1 className="mb-4 navMenuFont">{t("app_title")}</h1>
                  <h5 className="h2Font">{t("home4")}</h5>
                </div>
              </Container>
            </div>
          </div>

        </Slider>
      </div>
{/* BRANDS - Kept as requested */}
<Brands />

{/* --- NEW MODERN ABOUT SECTION --- */}
<div id="about" className="modern-about-section">
  <Container>
    {/* Row 1: Introduction */}
    <Row className="align-items-center mb-5" data-aos="fade-up">
      <Col lg={6} className="order-2 order-lg-1">
        <div className="about-content-card">
          <h2 className="section-title">{t("about_us")}</h2>
          <div className="accent-line black"></div>
          <p className="mt-4 main-text">
           {t("about_p")}
          </p>
        </div>
        <br />
        <div className="portfolio-box">
          <h6 className="section-title2">{t("pf")}</h6>
          <div className="accent-line black"></div>
          <ul className="modern-list mt-4">
            <li><span>{t("pf1")}</span></li>
            <li><span>{t("pf2")}</span></li>
            <li><span>{t("pf3")}</span></li>
            <li><span>{t("pf4")}</span></li>
            <li><span>{t("pf5")}</span></li>
            <li><span>{t("pf6")}</span></li>
          </ul>
        </div>
      </Col>
      <Col lg={6} className="order-1 order-lg-2 mb-4 mb-lg-0">
        <div className="modern-img-wrapper1">
          <div className="about-img-main1 image-1"></div>
        </div>
      </Col>
    </Row>
     

 <Row className="align-items-center mb-5" data-aos="fade-up">
      <Col lg={6}>
        <div className="about-content-card px-lg-4">
          <h2 className="section-title">{t("core")}</h2>
          <div className="accent-line black"></div>
          <p className="mt-4 main-text">
          {t("aboutp1")}
          </p>
          <p className="mt-4 main-text">{t("aboutp2")}</p>

          <p className="mt-4 main-text">{t("target1p")}</p>
          <p className="mt-4 main-text">{t("targetp")}</p>
        </div>
      </Col>
      <Col lg={6} className="mb-4 mb-lg-0">
        <div className="modern-img-wrapper float-right">
          <div className="about-img-main image-3"></div>
        </div>
      </Col>
    </Row>
    <br />
    {/* Row 2: Supply Network & International Presence */}
    <Row className="align-items-center mb-5" data-aos="fade-up">
      <Col lg={6}>
        <div className="portfolio-box">
          <h2 className="section-title">{t("objectiv")}</h2>
          <div className="accent-line black"></div>
          <ul className="modern-list mt-4 ">
            <li><span>{t("ob1")}</span></li>
            <li><span>{t("ob2")}</span></li>
            <li><span>{t("ob3")}</span></li>
          </ul>
        </div>
        <br />
         <div className="why-choose-card">
          <h2 className="section-title">{t("why_chose_us")}</h2>
          <div className="accent-line black"></div>
          <ul className="whychoseuslist list-unstyled mt-4 main-text1">
            <li><BsCheckLg className="checkicon" /> {t("reason1")}</li>
            <li><BsCheckLg className="checkicon" /> {t("reason2")}</li>
            <li><BsCheckLg className="checkicon" /> {t("reason3")}</li>
          </ul>
        </div>
      </Col>
      <Col lg={6} className="mb-4 mb-lg-0">
        <div className="modern-img-wrapper float-right">
          <div className="about-img-main image-2"></div>
        </div>
      </Col>
    </Row>
  </Container>
</div>
      {/* SERVICES */}
<div id="services" className="h-service">
  <div className="overlay">
    <Container>
      <h2
        className={`text-center ${
          currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"
        }`}
        data-aos="fade-up" data-aos-duration="1000"
      >
        {t("services")}
      </h2>
      <div className="mb-5 d-flex justify-content-center" data-aos="fade-up" data-aos-duration="1000">
        <hr className="hr" />
      </div>

      {/* FIRST ROW: 3 ITEMS */}
      <Row className="justify-content-center">
        <Col lg={4} className="text-center my-lg-0 mb-5 px-3" data-aos="zoom-in" data-aos-duration="1000">
          <div>
            <MdOutlineContentCut className="serviceIcon" />
          </div>
          <h4 className={`my-lg-4 mt-3 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}>
            {t("service1")}
          </h4>
          <p>{t("service1_p")}</p>
          <ul className="ul list-unstyled p-0 m-0">
            <li>{t("service1_li1")}</li>
            <li>{t("service1_li2")}</li>
            <li>{t("service1_li3")}</li>
          </ul>
        </Col>

        <Col lg={4} className="text-center my-lg-0 mb-5 px-3" data-aos="zoom-in" data-aos-duration="1000">
          <div>
            <MdRoofing className="serviceIcon" />
          </div>
          <h4 className={`my-lg-4 mt-3 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}>
            {t("service2")}
          </h4>
          <p>{t("service2_p")}</p>
          <ul className="ul list-unstyled p-0 m-0">
            <li>{t("service2_li1")}</li>
            <li>{t("service2_li2")}</li>
            <li>{t("service2_li3")}</li>
            <li>{t("service2_li4")}</li>
          </ul>
        </Col>

        <Col lg={4} className="text-center my-lg-0 mb-5 px-3" data-aos="zoom-in" data-aos-duration="1000">
          <div>
            <GiCircularSawblade className="serviceIcon" />
          </div>
          <h4 className={`my-lg-4 mt-3 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}>
            {t("service3")}
          </h4>
          <p>{t("service3_p")}</p>
        </Col>
      </Row>

      {/* SECOND ROW: 2 NEW ITEMS */}
      <Row className="justify-content-center mt-lg-4">
       {/* OIL INDUSTRY */}
<Col lg={4} className="text-center mb-5 px-3" data-aos="zoom-in" data-aos-duration="1000">
 <a href={`${process.env.PUBLIC_URL}/docs/SV Profile.pdf`} target="_blank" rel="noopener noreferrer" className="service-link-wrapper">
      <div className="icon-wrapper">
        <GiOilDrum className="serviceIcon" />
      </div>
      <h4 className={`my-lg-4 mt-3 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}>
        {t("service4")}
      </h4>
    </a>
  <p>{t("service4_p")}</p>
  
  {/* The Text Link */}
  <a href={`${process.env.PUBLIC_URL}/docs/SV Profile.pdf`} target="_blank" rel="noopener noreferrer" className="pdf-text-link">
    <i className="far fa-file-pdf me-2"></i> {t("view_pdf")}
  </a>
</Col>

{/* SECURITY */}
<Col lg={4} className="text-center mb-5 px-3" data-aos="zoom-in" data-aos-duration="1000">
  <a href={`${process.env.PUBLIC_URL}/docs/EC - Combined Company Profile.pdf`} target="_blank"  className="service-link-wrapper">
    <div className="icon-wrapper">
      <GiShield className="serviceIcon" />
    </div>
    <h4 className={`my-lg-4 mt-3 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}>
      {t("service5")}
    </h4>
  </a>
  <p>{t("service5_p")}</p>
  
  {/* The Text Link */}
  <a href={`${process.env.PUBLIC_URL}/docs/EC - Combined Company Profile.pdf`} target="_blank" rel="noopener noreferrer" className="pdf-text-link">
    <i className="far fa-file-pdf me-2"></i> {t("view_pdf")}
  </a>
</Col>
      </Row>
    </Container>
  </div>
</div>
      {/* PRODUCTS */}
      <div id="products" className="h-products">
        <div className="prod-overflow">
          <Container className="text-center">
            <h2
              className={`${currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"}`}
              data-aos="fade-up" data-aos-duration="1000"
            >
              {t("products")}
            </h2>
            <div className="mb-5 d-flex justify-content-center" data-aos="fade-up" data-aos-duration="1000">
              <hr className="hr" />
            </div>
            <Row className="px-1 px-md-0">
              {products.en.map((p) => (
                <Col
                  xs={4}
                  md={3}
                  lg={3}
                  className="mb-4 px-lg-4 px-1 d-flex justify-content-center"
                  key={p.id}
                  data-aos="fade-up" data-aos-duration="1000"
                >
                  <Card
                    style={{ width: "15rem" }}
                    className="prod-card"
                    id={p.id}
                    onMouseEnter={() => setTooltipVisible(p.id)}
                    onMouseLeave={() => setTooltipVisible(null)}
                    onClick={() => setTooltipVisible(tooltipVisible === p.id ? null : p.id)} // Toggle on click
                  >
                    <Card.Img
                      variant="top"
                      src={p.img}
                      className="prod1 img-fluid"
                      alt={p.name}
                    />
                    <Card.Body>
                      <Card.Title
                        className={`card-title ${
                          currentLanguage.dir === "ltr" ? "h2Font" : "prof-title-rtl"
                        }`}
                      >
                        {p.name}
                      </Card.Title>
                      {tooltipVisible === p.id && (
                        <div className="tooltip">
                          <p>{p.description}</p>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </div>
      </div>
      {/* CONTACT */}
      <div id="contact">
        <div className="overlay">
          <Container>
            <Row>
              <Col lg={{ span: 6, order: 2 }} className=" contactFormCol">
                <div className="contact-us">
                  <h4
                    className={`mb-4 text-center ${
                      currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"
                    }`}
                  >
                    {t("contact_form")}
                  </h4>
                  <form ref={form} onSubmit={sendEmail}>
                    <div className="form-group">
                      <label htmlFor="name">{t("name")} :</label>
                      <input
                        type="text"
                        className="form-control form-control-sm my-1"
                        id="name"
                        placeholder={t("name")}
                        name="name"
                        required
                      />
                    </div>
                    <div className="form-group my-3">
                      <label htmlFor="email">{t("email")} :</label>
                      <input
                        type="email"
                        className="form-control form-control-sm my-1"
                        id="email"
                        placeholder={t("email")}
                        aria-describedby="emailHelp"
                        name="email"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">{t("message")} :</label>
                      <textarea
                        className="form-control form-control-sm my-1"
                        id="message"
                        placeholder={t("message")}
                        rows="3"
                        name="message"
                        required
                      ></textarea>
                    </div>
                    <div className="d-flex flex-row">
                      <Button
                        variant="primary"
                        className="mt-3 px-3 btn-sm"
                        type="submit"
                      >
                        {t("send_message")}
                      </Button>
                    </div>
                  </form>
                </div>
              </Col>
              <Col lg={{ span: 6, order: 1 }} className="text-center px-4 py-4">
                <h3
                  className={`mb-4 ${
                    currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"
                  }`}
                >
                  {t("app_title")}
                </h3>
                <p className="fs-7 mb-5">
                  Qandel Blbas Company. Founded in 2010, Qandel Blbas is a
                  local company operating in the fields of importing steel
                  and its different products and the production of Sandwich
                  Panels and distributing them across all the provinces of
                  the country.
                </p>
                <h6>{t("address")}</h6>
                <p className="px-5">{t("address_value")}</p>
                <h6>{t("phone")}</h6>
                <a href="tel:+9647734456622" className="contactLinks">
                  +964-773-445-6622
                </a>{" "}
                <br />
                <a href="tel:+9647509521000" className="contactLinks">
                  +964-750-952-1000
                </a>
                <h6>{t("email")}</h6>
                <a href="mailto:contact@qandelblbas.com" className="contactLinks">
                  contact@qandelblbas.com
                </a>
                <br />
                {/* Wrap this in a div to center it properly */}
<div className="mt-3 d-flex justify-content-center">
  <a 
    href="https://www.facebook.com/qandelblbasco/" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="facebook-link-crisp"
  >
    <div className="fb-icon-circle">
      <FaFacebookF className="fb-vector-icon" />
    </div>
    <span className="fb-text">Qandel Blbas Co</span>
  </a>
</div>
   
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div>
        <iframe
          title="runaky-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3220.8406758979345!2d44.021118415272284!3d36.17043148008313!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x400723178547ccf3%3A0x562341a87b27b3bc!2zUWFuZGVsIEJsYmFzIENvINi02LHZg9ipINmC2YbYr9mK2YQg2KjZhNio2KfYsw!5e0!3m2!1sen!2siq!4v1639757583802!5m2!1sen!2siq"
          width="100%"
          height="100% "
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
      <Footer />
    <GoTop id="topp" />
    </>
  );
};


export default Home;
